import { render } from "./howItWorks.vue?vue&type=template&id=eb2b6dd6"
import script from "./howItWorks.vue?vue&type=script&lang=js"
export * from "./howItWorks.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\david\\Desktop\\Netloud\\whiteLabel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__